// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__rv6j3","errors":"Errors_errors__1sZM9"};